
function replace_all(elementHTML, regex, replacements) {
	let regex_match = String(elementHTML.match(regex));
	while (regex_match !== 'null')
	{
		// replace start and end tags with correct values
		replacements.forEach(entry => {
			regex_match = regex_match.replace(entry.find, entry.replace);
		});

		elementHTML = elementHTML.replace(regex, regex_match);

		// get next one
		regex_match = String(elementHTML.match(regex));
	}

	return elementHTML;
}

export default {
	name: 'parseTranslationString',
	handler: {
		update: function (element, valueAccessor, allBindings) {
			// First get the latest data that we're bound to
			// let value = valueAccessor();

			// Next, whether or not the supplied model property is observable, get its current value
			// let valueUnwrapped = ko.unwrap(value); // this is the value of parseTranslationString

			// Grab some more data from another binding property
			// TODO : support multiple links and icons ???
			let link = allBindings.get('link'); // if it exists...

			let button_icon = allBindings.get('button_icon'); // if it exists...
			let button_icon_html = '';
			if (button_icon)
				button_icon_html = "span class='" + button_icon + "'></span>&nbsp;";

			let elementHTML = $(element).text();

			// regex.... looks for {red}..{/red}
			elementHTML = replace_all(elementHTML, new RegExp('{red}.*?{/red}', 'i'), [
				{ find: '{red}', replace: "<span class='red'>" },
				{ find: '{/red}', replace: '</span>' }
			]);
			
			// regex.... looks for {grey}..{/grey}
			elementHTML = replace_all(elementHTML, new RegExp('{grey}.*?{/grey}', 'i'), [
				{ find: '{grey}', replace: "<span class='grey'>" },
				{ find: '{/grey}', replace: '</span>' }
			]);

			// regex.... looks for {green}..{/green}
			elementHTML = replace_all(elementHTML, new RegExp('{green}.*?{/green}', 'i'), [
				{ find: '{green}', replace: "<span class='green'>" },
				{ find: '{/green}', replace: '</span>' }
			]);

			// regex.... looks for {yellow}..{/yellow}
			elementHTML = replace_all(elementHTML, new RegExp('{yellow}.*?{/yellow}', 'i'), [
				{ find: '{yellow}', replace: "<span class='yellow'>" },
				{ find: '{/yellow}', replace: '</span>' }
			]);

			// regex.... looks for {orange}..{/orange}
			elementHTML = replace_all(elementHTML, new RegExp('{orange}.*?{/orange}', 'i'), [
				{ find: '{orange}', replace: "<span class='orange'>" },
				{ find: '{/orange}', replace: '</span>' }
			]);

			// regex.... looks for {darkblue}..{/darkblue}
			elementHTML = replace_all(elementHTML, new RegExp('{darkblue}.*?{/darkblue}', 'i'), [
				{ find: '{darkblue}', replace: "<span class='darkblue'>" },
				{ find: '{/darkblue}', replace: '</span>' }
			]);

			// regex.... looks for {bold}..{/bold}
			elementHTML = replace_all(elementHTML, new RegExp('{bold}.*?{/bold}', 'i'), [
				{ find: '{bold}', replace: '<b>' },
				{ find: '{/bold}', replace: '</b>' }
			]);

			// regex.... looks for {link}..{/link}
			elementHTML = replace_all(elementHTML, new RegExp('{link}.*?{/link}', 'i'), [
				{ find: '{link}', replace: '<a href=' + link + '>' },
				{ find: '{/link}', replace: '</a>' }
			]);

			// regex.... looks for {button}..{/button}
			elementHTML = replace_all(elementHTML, new RegExp('{button}.*?{/button}', 'i'), [
				{ find: '{button}', replace: "<button class='help_normal_btn' style='pointer-events: none; cursor: default;'>" + button_icon_html },
				{ find: '{/button}', replace: '</button>' }
			]);

			// regex.... looks for {grey_button}..{/grey_button}
			elementHTML = replace_all(elementHTML, new RegExp('{grey_button}.*?{/grey_button}', 'i'), [
				{ find: '{grey_button}', replace: "<button class='help_normal_btn grey' style='pointer-events: none; cursor: default;'>" + button_icon_html },
				{ find: '{/grey_button}', replace: '</button>' }
			]);

			// regex.... looks for {blue_button}..{/blue_button}
			elementHTML = replace_all(elementHTML, new RegExp('{blue_button}.*?{/blue_button}', 'i'), [
				{ find: '{blue_button}', replace: "<button class='help_normal_btn darkblue' style='pointer-events: none; cursor: default;'>" + button_icon_html },
				{ find: '{/blue_button}', replace: '</button>' }
			]);

			// regex.... looks for {break}..{/break}
			elementHTML = replace_all(elementHTML, new RegExp('{/break}', 'i'), [{ find: '{/break}', replace: '<br />' }]);

			$(element).html(elementHTML);
		}
	}
};
